// extracted by mini-css-extract-plugin
export default {"main":"_0fcbd14ccc _3b4cfb82ed","xmark":"_1832af69d1","fl_img":"_5a59e1e543 a60dbb0995"};